import { Form, Input } from "antd";
export default function BrandModifier({ originForm }) {
  const [form] = Form.useForm(originForm);
  return (
    <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 18 }}>
      <Form.Item
        style={{ display: "none" }}
        name="id"
      >
        <Input disabled />
      </Form.Item>
      <Form.Item 
        label="品牌名称" 
        name="name"
        rules={[
          {
            required: true,
            message: '品牌名称必须填写',
          },
          { 
            type: 'string',
            max: 10,
            message: '品牌名称最多只能输入10个字符',
          }
        ]}
      >
        <Input placeholder="请输入品牌名称" />
      </Form.Item>
    </Form>
  );
}
